import { Injectable } from '@angular/core';

import { Appointment } from '@modules/core/models/appointment';
import { CustomerDTO, PublicAppointmentResponseDTO } from '@paymash/sdk/api';
import { PaymentOptionsEnum } from '@modules/core/enums';
import { Customer } from '@modules/core/models/appointment/customer';
import { SalutationType } from '@modules/core/types';

@Injectable({
  providedIn: 'root',
})
export class AppointmentMapper {
  public mapToEntity(dto: PublicAppointmentResponseDTO): Appointment {
    return {
      appointmentId: dto.appointmentId,
      createdAt: dto.createdAt,
      customer: dto.customer ? this.mapCustomer(dto.customer) : null,
      endedAt: dto.endedAt,
      externalNote: dto.externalNote,
      invoiceId: dto.invoiceId,
      isCancelAllowedByCustomer: dto.isCancelAllowedByCustomer,
      paymentMethod: dto.paymentMethod as PaymentOptionsEnum,
      sequentId: dto.sequentId,
      services: dto.services,
      startedAt: dto.startedAt,
      status: dto.status,
      uuid: dto.uuid,
    };
  }

  private mapCustomer(customerDto: CustomerDTO): Customer {
    return {
      address: customerDto.address,
      email: customerDto.email,
      firstName: customerDto.firstName,
      lastName: customerDto.lastName,
      salutation: customerDto.salutation as SalutationType,
    };
  }
}
